@if (state(); as state) {
  <app-organization-sidebar-layout>
    <app-page-header>
      <div class="flex flex-col gap-2.5">
        <div class="flex gap-3 items-center">
          <ui-button
            [iconOnly]="true"
            mode="outlined"
            class="flex-none"
            [routerLink]="['/organizations', organizationId(), 'supplier-contracts']"
          >
            <ng-icon name="heroArrowLeft" size="20" class="!block" />
          </ui-button>
          <app-page-title class="flex-1">
            @if (state.isLoading) {
              <ui-skeleton class="block w-[400px] h-[36px] rounded-md" />
            } @else if (!state.error) {
              @if (state.data?.metadata?.createdAt; as createdAt) {
                {{
                  'cockpit.parseRequests.details.pageTitle'
                    | transloco
                      : {
                          date: (createdAt | date: 'dd.MM.yyyy'),
                          time: (createdAt | date: 'HH:mm'),
                        }
                }}
              }
            }
          </app-page-title>
          @if (state.data?.status === 'REQUESTED') {
            <ui-button
              mode="admin"
              *hasRole="['USER_ADMIN']"
              (click)="onClickPickup()"
              [loading]="isUpdateLoading()"
              [disabled]="isUpdateLoading()"
            >
              {{ 'cockpit.parseRequests.details.pickupButton' | transloco }}
            </ui-button>
          } @else if (
            state.data?.status === 'IN_PROGRESS' && !isDraftsLoading() && !draftsError()
          ) {
            <ui-button
              mode="admin"
              *hasRole="['USER_ADMIN']"
              (click)="onClickComplete()"
              [loading]="isUpdateLoading()"
              [disabled]="isUpdateLoading()"
            >
              {{ 'cockpit.parseRequests.details.completeButton' | transloco }}
            </ui-button>
          }
        </div>
        <app-parse-requests-details-breadcrumb-nav
          [organizationId]="organizationId()"
          [parseRequestId]="parseRequestId()"
        />
      </div>
    </app-page-header>

    @if (updateError()) {
      <section>
        <ui-alert color="error">
          <span slot="title">{{
            'cockpit.parseRequests.details.updateError.title' | transloco
          }}</span>
          <p>{{ 'cockpit.parseRequests.details.updateError.message' | transloco }}</p>
        </ui-alert>
      </section>
    }

    @if (!state.error) {
      <div class="flex flex-col gap-5">
        <app-parse-requests-details-nav *hasRole="'USER_ADMIN'" />

        <div>
          <router-outlet />
        </div>
      </div>
    } @else {
      <app-error-page
        [error]="state.error"
        (clickBack)="router.navigate(['/organizations', organizationId(), 'supplier-contracts'])"
        class="block"
        style="height: calc(100vh - 20rem)"
      />
    }
  </app-organization-sidebar-layout>
}
